import React, { Suspense, lazy } from 'react';
import type { RoadLayersMapLibreProps } from './RoadLayersMapLibre.types';

// Lazy-loaded map layer components for better performance
const PolandBorderMapLibre = lazy(() => import('../PolandBorderMapLibre').then(module => ({ default: module.PolandBorderMapLibre })));
const VoivodeshipBordersMapLibre = lazy(() => import('../VoivodeshipBordersMapLibre').then(module => ({ default: module.VoivodeshipBordersMapLibre })));
const NationalRoadsMapLibre = lazy(() => import('../NationalRoadsMapLibre').then(module => ({ default: module.NationalRoadsMapLibre })));
const VoivodeshipRoadsMapLibre = lazy(() => import('../VoivodeshipRoadsMapLibre').then(module => ({ default: module.VoivodeshipRoadsMapLibre })));

// Minimal loading fallback for map layers (should be fast and unobtrusive)
const MapLayerFallback: React.FC = () => null;

export const RoadLayersMapLibre = ({
  layerVisibility,
  onRoadContextMenu,
  isTaskFormOpen
}: RoadLayersMapLibreProps) => {

  return (
    <>
      {/* Poland Border Layer - Load only when visible */}
      {layerVisibility.polandBorder && (
        <Suspense fallback={<MapLayerFallback />}>
          <PolandBorderMapLibre visible={layerVisibility.polandBorder} />
        </Suspense>
      )}

      {/* Voivodeship Borders Layer - Load only when visible */}
      {layerVisibility.voivodeshipBorders && (
        <Suspense fallback={<MapLayerFallback />}>
          <VoivodeshipBordersMapLibre
            visible={layerVisibility.voivodeshipBorders}
          />
        </Suspense>
      )}

      {/* National Roads Layer - Load only when visible */}
      {layerVisibility.nationalRoads && (
        <Suspense fallback={<MapLayerFallback />}>
          <NationalRoadsMapLibre
            visible={layerVisibility.nationalRoads}
            onContextMenu={onRoadContextMenu}
            isTaskFormOpen={isTaskFormOpen}
          />
        </Suspense>
      )}

      {/* Voivodeship Roads Layer - Load only when visible */}
      {layerVisibility.voivodeshipRoads && (
        <Suspense fallback={<MapLayerFallback />}>
          <VoivodeshipRoadsMapLibre
            visible={layerVisibility.voivodeshipRoads}
            onContextMenu={onRoadContextMenu}
            isTaskFormOpen={isTaskFormOpen}
          />
        </Suspense>
      )}
    </>
  );
};
